import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Modal,
  ModalBody,
  ModalHeader,
  Row
} from "reactstrap"
import { connect } from "react-redux"
import { Link, useLocation, withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"

//Date Picker
import { registerLocale, setDefaultLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

import "assets/scss/datatables.scss"
import ptBR from "date-fns/locale/pt-BR"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import moment from "moment"
import {
  buscarContasPagarAtrasados,
  buscarContasPagarHoje,
  buscarContasPagarMes,
  buscarContasPagarProximosMeses,
  buscarLancamento,
  buscarPlanoContas,
  cadastrarLancamento,
  editarLancamento,
  estornarPagamentoLancamento,
  pagarLancamento,
  relatorioExecutar,
  removerLancamento,
  removerLancamentoSerie,
} from "../../store/auth/profile/actions"
import toastr from "toastr"
import OverView from "./overview"
import CardWelcome from "./card-welcome"
import MiniWidget from "./mini-widget"
import usePermission from "helpers/permission/usePermission"
import LancamentoModal from "pages/ContasPagar/lancamento-modal"
import PagamentoLancamentoModal from "pages/ContasPagar/pagamento-lancamento-modal"
import ContasPagarTable from "pages/ContasPagar/contas-pagar-table"
import AlertaSemVinculo from "../../components/Common/alerta-sem-vinculo"
import { getCompanies, getCompaniesValuesByOptions, getCompanyOption, getDatasPeloPeriodo, getPeriodos } from "../../helpers/utils"
import FormFilterCompany from "../../components/Common/form-filter-company"
import FormFilterPeriod from "../../components/Common/form-filter-period"
import FormFilterSelect from "../../components/Common/form-filter-select"
import { navegarBreadCrumb } from "../../store/navigator/actions"
import { Filters } from "../../common/data/definitions"
import FormFilterFornecedor from "../../components/Common/form-filter-fornecedor"

registerLocale("ptBR", ptBR)
setDefaultLocale("ptBR")

const brazilMoment = (...args) => moment(...args)

const ContasPagar = props => {

  const [despesa, setDespesa] = useState()
  const [modal, setModal] = useState(false)
  const [modalPagamento, setModalPagamento] = useState(false)
  const [modalExcluir, setModalExcluir] = useState(false)
  const [modalEstornar, setModalEstonar] = useState(false)
  const [emissaoStartDate, setEmissaoStartDate] = useState(moment().startOf('month').toDate())
  const [emissaoEndDate, setEmissaoEndDate] = useState(moment().endOf('month').toDate())

  const [vencimentoStartDate, setVencimentoStartDate] = useState(moment().startOf('month').toDate())
  const [vencimentoEndDate, setVencimentoEndDate] = useState(moment().endOf('month').toDate())

  const [periodsEmissao, setPeriodsEmissao] = useState([])
  const [periodsVencimento, setPeriodsVencimento] = useState([])
  const [emissaoPeriod, setEmissaoPeriod] = useState(null)
  const [vencimentoPeriod, setVencimentoPeriod] = useState(null)
  const location = useLocation();
  const [situation, setSituation] = useState(null)

  const [companies, setCompanies] = useState([])
  const [companiesOptions, setCompaniesOptions] = useState([])
  const [tipoConta, setTipoConta] = useState("")
  const [contas, setContas] = useState([])
  const [fornecedor, setFornecedor] = useState()
  const [recorrencia, setRecorrencia] = useState("")
  const [escopoExclusao, setEscopoExclusao] = useState("esta")
  const [filters, setFilters] = useState(null)
  const tableRef = useRef()
  const possuiVinculo = (props.user?.vinculos || []).some(vinculo => ["A", "T"].includes(vinculo.vinculo_status))

  const [reports, setReports] = useState([
    {
      title: "",
      icon: "mdi mdi-note-multiple-outline",
      color: "warning",
      value: "",
      desc: "",
      loading: true
    },
    {
      title: "",
      icon: "mdi mdi-note-multiple-outline",
      color: "primary",
      value: "",
      desc: "",
      loading: true
    },
    {
      title: "",
      icon: "mdi mdi-note-multiple-outline",
      color: "info",
      value: "",
      desc: "",
      loading: true
    },
    {
      title: "",
      icon: "mdi mdi-note-multiple-outline",
      color: "danger",
      value: "",
      desc: "",
      loading: true
    }
  ])

  const usePermissionInsert = usePermission('contasPagar_inserir')
  const usePermissionRemove = usePermission('contasPagar_excluir')
  const usePermissionEdit = usePermission('contasPagar_editar')


  useEffect(() => {
    const { tmpPeriods } = getPeriodos(true)
    const periodosVencimento = getPeriodos(false, true)

    setPeriodsEmissao(tmpPeriods)
    setPeriodsVencimento(periodosVencimento.tmpPeriods)

    if (props.user) {
      if(props.dashboardFilters.companiesSelected) setCompanies(props.dashboardFilters.companiesSelected)

      if(possuiVinculo) {
        const companiesId = getCompaniesValuesByOptions(props.dashboardFilters.companiesSelected)
        pesquisar(companiesId, periodosVencimento.primeiroPeriodo)
        props.buscarContasPagarHoje({ company: companiesId });
        props.buscarContasPagarProximosMeses({ company: companiesId });
        props.buscarContasPagarAtrasados({ company: companiesId });
        props.buscarContasPagarMes({ company: companiesId });
        props.buscarPlanoContas({ company: companiesId });
      }
    }
    props.navegarBreadCrumb( {title: `menu.label.bills`, link: location.pathname })
    return () => {
      setPeriodsEmissao([])
    }
  }, [props.user])

  useEffect(() => {
    if (companies && companies.length > 0) {
      const empresas = getCompaniesValuesByOptions(companies)
      props.buscarPlanoContas({ company: empresas })
    }
  }, [companies])

  useEffect(() => {
    if(props.user?.usuario_info && props.user?.usuario_info?.perfil?.administrador && Array.isArray(props.empresas)) {
      let companiesOptions = props.empresas.map(empresa => getCompanyOption(empresa));
      setCompaniesOptions(companiesOptions)
    } else {
      let companiesOptions = getCompanies(props.user)
      setCompaniesOptions(companiesOptions)
    }
    return () => {
      setCompaniesOptions([])
    }
  }, [props.user, props.empresas])

  useEffect(() => {
    if (Array.isArray(props.planoContas)) {
      const opcoes = props.planoContas.map(plano => ({
        label: `${plano.codigo} - ${plano.descricao}`,
        value: plano.codigo,
      }))
      setContas(opcoes)
    } else {
      setContas([])
    }
    return () => {
      setContas([])
    }
  }, [props.planoContas])

  const describeDiff = (A, B, numberOnly = false) => {
    A = parseFloat(A)
    B = parseFloat(B)

    const diff = A && B ? (100 * Math.abs((B - A) / B)).toFixed(2) : 0

    if (numberOnly) {
      return parseInt(diff)
    }

    return A >= B ? `+ ${ diff } %` : `- ${ diff } %`
  }

  const abbreviateNumber = (num, fixed) => {
    if (num === null) {
      return null
    } // terminate early
    if (num === 0) {
      return "0"
    } // terminate early
    fixed = !fixed || fixed < 0 ? 0 : fixed // number of decimal places to show
    var b = num.toPrecision(2).split("e"), // get power
      k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
      c =
        k < 1
          ? num.toFixed(0 + fixed)
          : (num / Math.pow(10, k * 3)).toFixed(1 + fixed), // divide by power
      d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
      e = d + ["", "K", "M", "B", "T"][k] // append power
    return e
  }

  useEffect(() => {
    const nextMonth = brazilMoment(new Date()).add(1, 'month').format("MMM")
    const otherNextMonth = brazilMoment(new Date()).add(3, 'month').format("MMM")

    setReports([
      {
        title: props.t("contaspagar.miniwidget.pagar_hoje"),
        icon: "mdi mdi-note-multiple-outline",
        color: "warning",
        value:
          props.contasPagarHoje && props.contasPagarHoje.periodo
            ? parseFloat(
              props.contasPagarHoje.periodo.valor || 0
            ).toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL"
            })
            : 0,
        desc: describeDiff(
          props.contasPagarHoje && props.contasPagarHoje.periodo
            ? props.contasPagarHoje.periodo.valor || 0
            : 0,
          props.contasPagarHoje &&
          props.contasPagarHoje.periodoAnterior
            ? props.contasPagarHoje.periodoAnterior.valor || 0
            : 0
        ),
        loading: props.contasPagarHojeLoading,
        series: [{
          name: "Valor",
          data:
            props.contasPagarHoje && props.contasPagarHoje.detalhado
              ? props.contasPagarHoje.detalhado.map(det => det.valor)
              : []
        }],
        diff: describeDiff(
          props.contasPagarHoje && props.contasPagarHoje.periodo
            ? props.contasPagarHoje.periodo.valor || 0
            : 0,
          props.contasPagarHoje &&
          props.contasPagarHoje.periodoAnterior
            ? props.contasPagarHoje.periodoAnterior.valor || 0
            : 0,
          true
        ),
        options: {
          chart: { sparkline: { enabled: !0 } },
          stroke: { curve: "smooth", width: 2 },
          colors: ["#f1b44c"],
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: !1,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [25, 100, 100, 100]
            }
          },
          tooltip: {
            fixed: { enabled: !1 },
            x: { show: !1 },
            marker: { show: !1 }
          },
          yaxis: {
            labels: {
              formatter: function(val, object) {
                return abbreviateNumber(val)
              }
            }
          }
        }
      },
      {
        title: props.t("contaspagar.miniwidget.pagar_mes", { mes: brazilMoment(props.currentPeriod).format("MMM") }),
        icon: "mdi mdi-note-multiple-outline",
        color: "primary",
        value:
          props.contasPagarMes && props.contasPagarMes.periodo
            ? parseFloat(
              props.contasPagarMes.periodo.valor || 0
            ).toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL"
            })
            : 0,
        desc: describeDiff(
          props.contasPagarMes && props.contasPagarMes.periodo
            ? props.contasPagarMes.periodo.valor || 0
            : 0,
          props.contasPagarMes &&
          props.contasPagarMes.periodoAnterior
            ? props.contasPagarMes.periodoAnterior.valor || 0
            : 0
        ),
        loading: props.loadingDashboardNotasMeses,
        series: [
          {
            name: "Valor",
            data:
              props.contasPagarMes && props.contasPagarMes.detalhado
                ? props.contasPagarMes.detalhado.map(det => det.valor)
                : []
          }
        ],
        diff: describeDiff(
          props.contasPagarMes && props.contasPagarMes.periodo
            ? props.contasPagarMes.periodo.valor || 0
            : 0,
          props.contasPagarMes &&
          props.contasPagarMes.periodoAnterior
            ? props.contasPagarMes.periodoAnterior.valor || 0
            : 0,
          true
        ),
        options: {
          chart: { sparkline: { enabled: !0 } },
          stroke: { curve: "smooth", width: 2 },
          colors: ["#f1b44c"],
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: !1,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [25, 100, 100, 100]
            }
          },
          tooltip: {
            fixed: { enabled: !1 },
            x: { show: !1 },
            marker: { show: !1 }
          },
          yaxis: {
            labels: {
              formatter: function(val, object) {
                return abbreviateNumber(val)
              }
            }
          }
        }
      },
      {
        title: props.t("contaspagar.miniwidget.pagar_proximos_3_meses", { inicio: nextMonth, fim: otherNextMonth }),
        icon: "mdi mdi-note-multiple-outline",
        color: "info",
        value:
          props.contasPagarProximosMeses && props.contasPagarProximosMeses.periodo
            ? parseFloat(
              props.contasPagarProximosMeses.periodo.valor || 0
            ).toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL"
            })
            : 0,
        desc: describeDiff(
          props.contasPagarProximosMeses && props.contasPagarProximosMeses.periodo
            ? props.contasPagarProximosMeses.periodo.valor || 0
            : 0,
          props.contasPagarProximosMeses &&
          props.contasPagarProximosMeses.periodoAnterior
            ? props.contasPagarProximosMeses.periodoAnterior.valor || 0
            : 0
        ),
        loading: props.loadingDashboardNotasMeses,
        series: [
          {
            name: "Valor",
            data:
              props.contasPagarProximosMeses && props.contasPagarProximosMeses.detalhado
                ? props.contasPagarProximosMeses.detalhado.map(det => det.valor)
                : []
          }
        ],
        diff: describeDiff(
          props.contasPagarProximosMeses && props.contasPagarProximosMeses.periodo
            ? props.contasPagarProximosMeses.periodo.valor || 0
            : 0,
          props.contasPagarProximosMeses &&
          props.contasPagarProximosMeses.periodoAnterior
            ? props.contasPagarProximosMeses.periodoAnterior.valor || 0
            : 0,
          true
        ),
        options: {
          chart: { sparkline: { enabled: !0 } },
          stroke: { curve: "smooth", width: 2 },
          colors: ["#f1b44c"],
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: !1,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [25, 100, 100, 100]
            }
          },
          tooltip: {
            fixed: { enabled: !1 },
            x: { show: !1 },
            marker: { show: !1 }
          },
          yaxis: {
            labels: {
              formatter: function(val, object) {
                return abbreviateNumber(val)
              }
            }
          }
        }
      },
      {
        title: props.t("contaspagar.miniwidget.atrasados_12_meses"),
        icon: "mdi mdi-note-multiple-outline",
        color: "danger",
        value:
          props.contasPagarAtrasados && props.contasPagarAtrasados.periodo
            ? parseFloat(
              props.contasPagarAtrasados.periodo.valor || 0
            ).toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL"
            })
            : 0,
        desc: describeDiff(
          props.contasPagarAtrasados && props.contasPagarAtrasados.periodo
            ? props.contasPagarAtrasados.periodo.valor || 0
            : 0,
          props.contasPagarAtrasados && props.contasPagarAtrasados.periodoAnterior
            ? props.contasPagarAtrasados.periodoAnterior.valor || 0
            : 0
        ),
        loading: props.loadingDashboardNotasAnos,
        series: [
          {
            name: "Valor",
            data:
              props.contasPagarAtrasados && props.contasPagarAtrasados.detalhado
                ? props.contasPagarAtrasados.detalhado.map(det => det.valor)
                : []
          }
        ],
        diff: describeDiff(
          props.contasPagarAtrasados && props.contasPagarAtrasados.periodo
            ? props.contasPagarAtrasados.periodo.valor || 0
            : 0,
          props.contasPagarAtrasados && props.contasPagarAtrasados.periodoAnterior
            ? props.contasPagarAtrasados.periodoAnterior.valor || 0
            : 0,
          true
        ),
        options: {
          chart: { sparkline: { enabled: !0 } },
          stroke: { curve: "smooth", width: 2 },
          colors: ["#f1b44c"],
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: !1,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [25, 100, 100, 100]
            }
          },
          tooltip: {
            fixed: { enabled: !1 },
            x: { show: !1 },
            marker: { show: !1 }
          },
          yaxis: {
            labels: {
              formatter: function(val, object) {
                return abbreviateNumber(val)
              }
            }
          }
        }
      }
    ])

    return () => setReports([])
  }, [
    props.contasPagarHoje,
    props.contasPagarMes,
    props.contasPagarProximosMeses,
    props.contasPagarAtrasados,
    props.t
  ])

  const populateFiltros = (companiesSelected, periodSelected) => {
    const filters = []
    const empresas = getCompaniesValuesByOptions(companiesSelected || companies)
    if (empresas) filters.push({ id: "idEmpresa", value: empresas })

    let datasPeloPeriodo = getDatasPeloPeriodo(
      emissaoPeriod,
      emissaoStartDate,
      emissaoEndDate
    )

    if (datasPeloPeriodo) {
      filters.push({
        id: "emissao",
        value: datasPeloPeriodo.inicio,
        condition: Filters.greaterThanOrEqualTo,
      })
      filters.push({
        id: "emissao",
        value: datasPeloPeriodo.fim,
        condition: Filters.lessThanOrEqualTo,
      })
    }

    let periodo = periodSelected || vencimentoPeriod

    let datasPeloPeriodoVencimento = getDatasPeloPeriodo(
      periodo,
      vencimentoStartDate,
      vencimentoEndDate
    )
    if (datasPeloPeriodoVencimento) {

      if (!emissaoPeriod) {
        setVencimentoPeriod(periodo)
      }
      if (!emissaoStartDate) {
        setVencimentoStartDate(datasPeloPeriodo.inicio)
      }
      if (!emissaoEndDate) {
        setVencimentoEndDate(datasPeloPeriodo.fim)
      }

      filters.push({
        id: "vencimento",
        value: datasPeloPeriodoVencimento.inicio,
        condition: Filters.greaterThanOrEqualTo,
      })
      filters.push({
        id: "vencimento",
        value: datasPeloPeriodoVencimento.fim,
        condition: Filters.lessThanOrEqualTo,
      })
    }

    if (situation) filters.push({ id: "situation", value: situation })
    if (tipoConta) filters.push({ id: "tipoConta", value: tipoConta })
    if (fornecedor) filters.push({ id: "fornec", value: fornecedor.value })
    if (recorrencia) filters.push({ id: "recorrencia", value: recorrencia })
    setFilters(filters)
  }

  const pesquisar = (companiesSelected, primeiroPeriodo) => {
    populateFiltros(companiesSelected, primeiroPeriodo)
    setTimeout(() => {
      tableRef?.current?.search()
      console.log("pesquisar", companiesSelected, primeiroPeriodo)
    }, 300)
  }

  const mapErroBackend = (data, t) => {
    if (!data) return null
    if (data.message === "Network Error" || data.response?.status >= 500) {
      return t("erro.servidor_indisponivel") || "Erro do servidor"
    }
    const status = data.response?.status
    const body = data.response?.data
    if (status === 404) return t("contaspagar.recorrencia.erro.serie_nao_encontrada")
    if (status === 400 && body?.erro === "CONFLITO_PAGA") return t("contaspagar.recorrencia.erro.conflito_paga")
    if (status === 400 && /vazio|atualizar/i.test(body?.message || "")) return t("contaspagar.recorrencia.erro.escopo_vazio")
    if (status === 400 && /pag/i.test(body?.message || "")) return t("contaspagar.recorrencia.erro.desde_id_paga")
    if (status === 400) return body?.message || body?.erro || "Erro de validação"
    return null
  }

  useEffect(() => {
    const r =
      props.editarLancamentoSerieResult || props.removerLancamentoSerieResult
    if (r === undefined) return
    if (r instanceof Error || r?.response) {
      const msg = mapErroBackend(r, props.t)
      if (msg) toastr.error(msg)
    } else {
      pesquisar()
    }
  }, [props.editarLancamentoSerieResult, props.removerLancamentoSerieResult])

    useEffect(() => {
      const r = props.cadastradoLancamentoResult || props.editadoLancamentoResult || props.removidoLancamentoResult || props.pagoLancamentoResult || props.estornadoLancamentoResult
      console.log("r", r)
      if (r === undefined) return
      if (r instanceof Error || r?.response) {
        const msg = mapErroBackend(r, props.t)
        if (msg) toastr.error(msg)
      } else {
        pesquisar()
      }
    }, [props.cadastradoLancamentoResult, props.editadoLancamentoResult, props.removidoLancamentoResult, props.pagoLancamentoResult, props.estornadoLancamentoResult ])

  useEffect(() => {
    const r = props.previewRecorrenciaResult
    if (r === undefined) return
    if (r instanceof Error || r?.response) {
      const msg = mapErroBackend(r, props.t) || props.t("contaspagar.recorrencia.erro.preview_falhou")
      toastr.error(msg)
    }
  }, [props.previewRecorrenciaResult])

  const onPickEmissaoStartDate = date => {
    setEmissaoStartDate(date)
    setEmissaoEndDate(date)
  }

  const onPickVencimentoStartDate = date => {
    setVencimentoStartDate(date)
    setVencimentoEndDate(date)
  }

  const printPDF = () => {

    let emissaoStart
    let emissaoEnd
    if (emissaoPeriod && emissaoPeriod !== 'period') {
      emissaoStart = brazilMoment(emissaoPeriod).clone().startOf('month').format('YYYY-MM-DD')
      emissaoEnd = brazilMoment(emissaoPeriod).clone().endOf('month').format('YYYY-MM-DD')
    } else if(emissaoStartDate && emissaoEndDate) {
      emissaoStart = brazilMoment(emissaoStartDate).clone().format('YYYY-MM-DD')
      emissaoEnd = brazilMoment(emissaoEndDate).clone().format('YYYY-MM-DD')
    } else {
      emissaoStart = brazilMoment(new Date()).clone().startOf('month').format('YYYY-MM-DD')
      emissaoEnd = brazilMoment(new Date()).clone().endOf('month').format('YYYY-MM-DD')
    }

    let vencimentoStart
    let vencimentoEnd
    if (vencimentoPeriod && vencimentoPeriod !== 'period') {
      vencimentoStart = brazilMoment(vencimentoPeriod).clone().startOf('month').format('YYYY-MM-DD')
      vencimentoEnd = brazilMoment(vencimentoPeriod).clone().endOf('month').format('YYYY-MM-DD')
    } else if(vencimentoStartDate && vencimentoEndDate) {
      vencimentoStart = brazilMoment(vencimentoStartDate).clone().format('YYYY-MM-DD')
      vencimentoEnd = brazilMoment(vencimentoEndDate).clone().format('YYYY-MM-DD')
    } else {
      vencimentoStart = brazilMoment(new Date()).clone().startOf('month').format('YYYY-MM-DD')
      vencimentoEnd = brazilMoment(new Date()).clone().endOf('month').format('YYYY-MM-DD')
    }

    props.relatorioExecutar({
      company: getCompaniesValuesByOptions(companies),
      emissaoStart,
      emissaoEnd,
      vencimentoStart,
      vencimentoEnd,
      situation,
      tipoConta,
      codigoFornecedor: fornecedor,
      reportName: 'contas_pagar',
    });
  }

  const toggleModal = item => {
    console.log("toggleModal", item)
    setModal(!modal)
    if(item?.id) {
      props.buscarLancamento({id: item?.id})
    } else {
      setDespesa({})
    }
  }

  useEffect(() => {
    console.log("props.buscarLancamentoResult", props.buscarLancamentoResult)
    if(props.buscarLancamentoResult) {
      setDespesa(props.buscarLancamentoResult)
    }
  }, [props.buscarLancamentoResult])

  const toggleModalPagamento = (item) => {
    console.log("toggleModalPagamento", item)
    setModalPagamento(!modalPagamento)
    if (item?.id) {
      props.buscarLancamento({ id: item?.id })
    }
  }

  const toggleModalRemove = item => {
    console.log("toggleModalRemove", item)
    setEscopoExclusao("esta")
    setModalExcluir(!modalExcluir)
    if (item?.id) {
      props.buscarLancamento({ id: item?.id })
    }
  }

  const toggleModalEstornar = item => {
    console.log("toggleModalEstornar", item)
    setModalEstonar(!modalEstornar)
    if (item?.id) {
      props.buscarLancamento({ id: item?.id })
    }
  }

  const saveLancamento = despesa => {
    setModal(!modal)
    if(despesa.id) {
      props.editarLancamento(despesa)
    } else {
      props.cadastrarLancamento(despesa)
    }
  }

  const payLancamento = despesa => {
    setModalPagamento(!modalPagamento)
    props.pagarLancamento(despesa)
  }

  const doDeleteLancamento = () => {
    setModalExcluir(false)
    if (despesa?.id_recorrencia && escopoExclusao !== "esta") {
      const params = { escopo: escopoExclusao, idEmpresa: despesa.idEmpresa }
      if (escopoExclusao === "futuras") params.desde_id = despesa.id
      props.removerLancamentoSerie({
        id_recorrencia: despesa.id_recorrencia,
        params,
      })
    } else {
      props.removerLancamento(despesa)
    }
    setEscopoExclusao("esta")
  }

  const estornarLancamento = () => {
    setModalEstonar(!modalEstornar)
    props.estornarPagamentoLancamento(despesa)
  }

  if (!props.user || !props.user.vinculos.length || !(props.user.vinculos || []).filter(e => ["A", "T"].find(status => status == e.vinculo_status)).length) {
    return (
        <AlertaSemVinculo/>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="menu.label.bills" />

          <Row>
            <Col lg="12">
              <div>
                <Row>
                  <OverView company={companies} />

                  <Col xl="8">
                    <CardWelcome />

                    <Row>
                      <MiniWidget reports={reports} />
                    </Row>
                  </Col>
                </Row>

                <Card>
                  <CardBody>
                    <h4 className="card-title mb-3">
                      {props.t("contaspagar.titulo.filtros")}
                    </h4>

                    <Form>
                      <Row>
                        <div className="col col-12 col-md-4 ">
                          <FormFilterCompany
                            attribute="companies"
                            value={companies}
                            description={props.t("contaspagar.filtro.empresas")}
                            setValue={value => setCompanies(value)}
                            options={companiesOptions}
                            multiple={true}
                            hasSelectAll={
                              !(
                                props.user?.usuario_info &&
                                props.user?.usuario_info?.perfil?.administrador
                              )
                            }
                          />
                        </div>
                        <div className="col col-12 col-md-4">
                          <FormFilterPeriod
                            periodAttribute="emissaoPeriod"
                            periodDescription={props.t(
                              "contaspagar.filtro.emissao"
                            )}
                            periodValue={emissaoPeriod}
                            periodChangeHandeler={value =>
                              setEmissaoPeriod(value)
                            }
                            options={periodsEmissao}
                            placeHolder={props.t(
                              "contaspagar.filtro.placeholder.data"
                            )}
                            startDateAttribute="emissaoStartDate"
                            startDateDescription={props.t(
                              "contaspagar.filtro.data_inicial"
                            )}
                            startDateValue={emissaoStartDate}
                            startDateChangeHandeler={onPickEmissaoStartDate}
                            endDateAttribute="emissaoEndDate"
                            endDateDescription={props.t(
                              "contaspagar.filtro.data_final"
                            )}
                            endDateValue={emissaoEndDate}
                            endDateChangeHandeler={date =>
                              setEmissaoEndDate(date)
                            }
                            t={props.t}
                          />
                        </div>
                        <div className="col col-12 col-md-4">
                          <FormFilterPeriod
                            periodAttribute="vencimentoPeriod"
                            periodDescription={props.t(
                              "contaspagar.filtro.vencimento"
                            )}
                            periodValue={vencimentoPeriod}
                            periodChangeHandeler={value =>
                              setVencimentoPeriod(value)
                            }
                            options={periodsVencimento}
                            placeHolder={props.t(
                              "contaspagar.filtro.placeholder.data"
                            )}
                            startDateAttribute="vencimentoStartDate"
                            startDateDescription={props.t(
                              "contaspagar.filtro.data_inicial"
                            )}
                            startDateValue={vencimentoStartDate}
                            startDateChangeHandeler={onPickVencimentoStartDate}
                            endDateAttribute="vencimentoEndDate"
                            endDateDescription={props.t(
                              "contaspagar.filtro.data_final"
                            )}
                            endDateValue={vencimentoEndDate}
                            endDateChangeHandeler={date =>
                              setVencimentoEndDate(date)
                            }
                            t={props.t}
                          />
                        </div>

                        <div className="col col-auto">
                          <FormFilterSelect
                            attribute="situation"
                            description={props.t("contaspagar.filtro.situacao")}
                            value={situation || ""}
                            changeHandeler={value => setSituation(value)}
                            options={[
                              {
                                value: "",
                                label: props.t(
                                  "contaspagar.filtro.situacao.todas"
                                ),
                                defaultValue: true,
                              },
                              {
                                value: "atrasada",
                                label: props.t(
                                  "contaspagar.filtro.situacao.atrasada"
                                ),
                              },
                              {
                                value: "pagar",
                                label: props.t(
                                  "contaspagar.filtro.situacao.pagar"
                                ),
                              },
                              {
                                value: "pago",
                                label: props.t(
                                  "contaspagar.filtro.situacao.pago"
                                ),
                              },
                            ]}
                          />
                        </div>
                      </Row>
                      <Row>
                        <div className="col col-auto">
                          <FormFilterSelect
                            attribute="recorrencia"
                            description={props.t(
                              "contaspagar.filtro.recorrencia"
                            )}
                            value={recorrencia}
                            changeHandeler={value => setRecorrencia(value)}
                            options={[
                              {
                                value: "",
                                label: props.t(
                                  "contaspagar.filtro.recorrencia.todas"
                                ),
                                defaultValue: true,
                              },
                              {
                                value: "recorrente",
                                label: props.t(
                                  "contaspagar.filtro.recorrencia.recorrentes"
                                ),
                              },
                              {
                                value: "avulsa",
                                label: props.t(
                                  "contaspagar.filtro.recorrencia.avulsas"
                                ),
                              },
                            ]}
                          />
                        </div>

                        <div className="col col-12 col-md-6">
                          <FormFilterSelect
                            attribute="centro_custo"
                            description={props.t(
                              "contaspagar.filtro.centro_custo"
                            )}
                            value={tipoConta || ""}
                            changeHandeler={value => setTipoConta(value)}
                            options={[
                              {
                                value: "",
                                label: props.t(
                                  "contaspagar.filtro.centro_custo.todos"
                                ),
                                defaultValue: true,
                              },
                              ...contas,
                            ]}
                          />
                        </div>

                        <div className="col col-12 col-md-6">
                          <FormFilterFornecedor
                            attribute="fornecedor"
                            description={props.t(
                              "contaspagar.filtro.fornecedor"
                            )}
                            empresas={getCompaniesValuesByOptions(companies)}
                            value={fornecedor}
                            setValue={setFornecedor}
                          />
                        </div>

                        <div className="col col-auto align-self-start mt-md-4 pt-1 row">
                          <div className="mt-3 col col-auto">
                            <Button
                              color="primary"
                              onClick={() => pesquisar()}
                              disabled={!usePermission("contasPagar_listar")}
                            >
                              {props.t("contaspagar.botao.buscar")}
                            </Button>
                          </div>
                          {!props.executaRelatorioLoading && (
                            <div className="mt-3 col col-auto">
                              <Button
                                type="button"
                                color="light"
                                onClick={() => printPDF()}
                              >
                                <i className="bx bx-download align-middle font-size-16 me-2"></i>
                                {props.t("contaspagar.botao.pdf")}
                              </Button>
                            </div>
                          )}
                        </div>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>

                {filters && (
                  <Card>
                    <CardBody>
                      <div className="button-items my-3">
                        <Link to="#">
                          <Button
                            type="button"
                            color="success"
                            className="btn-rounded waves-effect waves-light"
                            onClick={() => toggleModal(null)}
                            disabled={!usePermissionInsert}
                          >
                            <i className="bx bx-plus" />{" "}
                            {props.t("contaspagar.botao.criar_lancamento")}
                          </Button>
                        </Link>
                      </div>

                      <ContasPagarTable
                        ref={tableRef}
                        filters={filters}
                        usePermissionEdit={usePermissionEdit}
                        usePermissionRemove={usePermissionRemove}
                        onEditar={toggleModal}
                        onRemover={toggleModalRemove}
                        onPagar={toggleModalPagamento}
                        onEstornar={toggleModalEstornar}
                      />
                    </CardBody>
                  </Card>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <LancamentoModal
        despesa={despesa}
        isOpen={modal}
        toggle={toggleModal}
        saveLancamento={saveLancamento}
        companies={
          companies && companies.length > 0 ? companies : companiesOptions
        }
      />
      <PagamentoLancamentoModal
        despesa={despesa}
        isOpen={modalPagamento}
        toggle={toggleModalPagamento}
        saveLancamento={payLancamento}
        companies={
          companies && companies.length > 0 ? companies : companiesOptions
        }
      />

      <Modal isOpen={modalExcluir}>
        <ModalHeader tag="h4">
          {props.t("contaspagar.modal.excluir.titulo")}
        </ModalHeader>
        <ModalBody>
          {despesa?.id_recorrencia ? (
            <Row form>
              <Col className="col-12">
                <p>{props.t("contaspagar.modal.excluir.serie.intro")}</p>
                <div className="form-check mb-2">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="del-esta"
                    checked={escopoExclusao === "esta"}
                    onChange={() => setEscopoExclusao("esta")}
                  />
                  <label className="form-check-label" htmlFor="del-esta">
                    {props.t("contaspagar.recorrencia.escopo.exclusao.esta")}
                  </label>
                </div>
                <div className="form-check mb-2">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="del-futuras"
                    checked={escopoExclusao === "futuras"}
                    onChange={() => setEscopoExclusao("futuras")}
                  />
                  <label className="form-check-label" htmlFor="del-futuras">
                    {props.t("contaspagar.recorrencia.escopo.exclusao.futuras")}
                  </label>
                </div>
                <div className="form-check mb-2">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="del-todas"
                    checked={escopoExclusao === "todas"}
                    onChange={() => setEscopoExclusao("todas")}
                  />
                  <label className="form-check-label" htmlFor="del-todas">
                    {props.t("contaspagar.recorrencia.escopo.exclusao.todas")}
                  </label>
                </div>
                <small className="text-muted">
                  {props.t("contaspagar.modal.excluir.serie.aviso_pagas")}
                </small>
              </Col>
            </Row>
          ) : (
            <Row form>
              <Col className="col-12">
                <p>{props.t("contaspagar.modal.excluir.confirmacao")}</p>
              </Col>
            </Row>
          )}
          <Row>
            <Col>
              <div className="text-right">
                <button
                  type="button"
                  className="btn btn-success save-event"
                  onClick={() => doDeleteLancamento()}
                >
                  {despesa?.id_recorrencia
                    ? props.t("contaspagar.modal.excluir.serie.confirmar")
                    : props.t("contaspagar.modal.excluir.confirmar")}
                </button>
                <button
                  type="button"
                  className="btn btn-light ms-2"
                  onClick={() => setModalExcluir(false)}
                >
                  {props.t("contaspagar.modal.excluir.cancelar")}
                </button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalEstornar}>
        <ModalHeader tag="h4">
          {props.t("contaspagar.modal.estornar.titulo")}
        </ModalHeader>
        <ModalBody>
          <Row form>
            <Col className="col-12">
              <p>{props.t("contaspagar.modal.estornar.confirmacao")}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="text-right">
                <button
                  type="danger"
                  className="btn btn-success save-event"
                  onClick={() => estornarLancamento()}
                >
                  {props.t("contaspagar.modal.estornar.confirmar")}
                </button>
                <button
                  type="button"
                  className="btn btn-light ms-2"
                  onClick={() => setModalEstonar(false)}
                >
                  {props.t("contaspagar.modal.estornar.cancelar")}
                </button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

ContasPagar.propTypes = {
  buscarContasPagarHoje: PropTypes.func,
  buscarContasPagarMes: PropTypes.func,
  buscarContasPagarProximosMeses: PropTypes.func,
  buscarContasPagarAtrasados: PropTypes.func,
  buscarPlanoContas: PropTypes.func,
  relatorioExecutar: PropTypes.func,
  cadastrarLancamento: PropTypes.func,
  editarLancamento: PropTypes.func,
  removerLancamento: PropTypes.func,
  buscarLancamento: PropTypes.func,
  removerLancamentoSerie: PropTypes.func,
  pagarLancamento: PropTypes.func,
  planoContas: PropTypes.array,
  previewRecorrenciaResult: PropTypes.any,
  editarLancamentoSerieResult: PropTypes.any,
  buscarLancamentoResult: PropTypes.any,
  removerLancamentoSerieResult: PropTypes.any,
  cadastradoLancamentoResult: PropTypes.any,
  editadoLancamentoResult: PropTypes.any,
  removidoLancamentoResult: PropTypes.any,
  pagoLancamentoResult: PropTypes.any,
  estornadoLancamentoResult: PropTypes.any,
}

const mapStatetoProps = state => {
  const { loadingDashboardNotasAnos } = state.Dashboard
  const {
    contasPagarHoje,
    contasPagarHojeLoading,
    contasPagarMes,
    contasPagarMesLoading,
    contasPagarProximosMeses,
    contasPagarProximosMesesLoading,
    contasPagarAtrasados,
    contasPagarAtrasadosLoading,
    executaRelatorioLoading,
    previewRecorrenciaResult,
    editarLancamentoSerieResult,
    removerLancamentoSerieResult,
    cadastradoLancamentoResult,
    editadoLancamentoResult,
    removidoLancamentoResult,
    pagoLancamentoResult,
    estornadoLancamentoResult,
    buscarLancamentoResult,
    planoContas,
    empresas,
  } = state.Profile
  const { user, dashboardFilters } = state.Login
  return {
    user,
    dashboardFilters,
    contasPagarHoje,
    contasPagarHojeLoading,
    contasPagarMes,
    contasPagarMesLoading,
    contasPagarProximosMeses,
    contasPagarProximosMesesLoading,
    contasPagarAtrasados,
    contasPagarAtrasadosLoading,
    executaRelatorioLoading,
    previewRecorrenciaResult,
    editarLancamentoSerieResult,
    removerLancamentoSerieResult,
    cadastradoLancamentoResult,
    editadoLancamentoResult,
    removidoLancamentoResult,
    pagoLancamentoResult,
    estornadoLancamentoResult,
    buscarLancamentoResult,
    planoContas,
    empresas,
    loadingDashboardNotasAnos,
  }
}

export default connect(mapStatetoProps, {
  buscarContasPagarHoje,
  buscarContasPagarMes,
  buscarContasPagarProximosMeses,
  buscarContasPagarAtrasados,
  buscarPlanoContas,
  relatorioExecutar,
  cadastrarLancamento,
  editarLancamento,
  removerLancamento,
  buscarLancamento,
  removerLancamentoSerie,
  pagarLancamento,
  estornarPagamentoLancamento,
  navegarBreadCrumb,
})(withTranslation()(withRouter(ContasPagar)))
